<style lang="sass">
    @import ../../common/styles/settings
    @import ../../common/styles/mixins
    @import calculator
</style>

<script>
    import AnimatedNumber from '../../common/components/AnimatedNumber.vue'
    import Modal from '../../common/components/Modal.vue'

    // const OIL_EQUIVALENCE = 10.7
    // const GAZ_ECONOMY_RATIO = 0.8

    export default {
        // components: {
        //     Modal,
        //     AnimatedNumber
        // },
        // props: {
        //     dataProps: {
        //         type: String,
        //         default: ''
        //     }
        // },
        // data () {
        //     return {
        //         displayPopin: false,
        //         displayResults: false,
        //         displayForm: false,
        //         form: {
        //             oil_annual_consumption: null,
        //             oil_unit_price: null,
        //             oil_annual_budget: 0,
        //             gaz_price: 0.00,
        //             gaz_subscription: 0.00,
        //             gaz_annual_consumption: 0,
        //             gaz_annual_consumption_budget: 0,
        //             gaz_annual_subscription: 0,
        //             gaz_annual_budget: 0,
        //             saving_nosub: 0,
        //             saving_sub: 0,
        //             email: ''
        //         },
        //         formEl: null
        //     }
        // },
        // watch: {
        //     form: {
        //         handler: 'updateFormValues',
        //         deep: true
        //     }
        // },
        // mounted () {
        //     let dataProps = this.dataProps ? JSON.parse(this.dataProps) : {}
        //     this.form = {...this.form, ...dataProps}

        //     this.formEl = this.$el.querySelector("form")
        //     this.displayForm = this.formEl.querySelector(".webform-confirmation") !== null
        // },
        // created () {
        //     this.$validator.localize('fr', {
        //         attributes: {
        //             oil_annual_consumption: 'La consommation de fioul',
        //             oil_unit_price: 'La prix unitaire'
        //         }
        //     })
        // },
        // methods: {
        //     updateFormValues (val) {
        //         const oilAnnualConsmption = parseInt(val.oil_annual_consumption)
        //         const oilUnitPrice = parseFloat(val.oil_unit_price)

        //         if(oilAnnualConsmption || oilUnitPrice) {
        //             this.displayForm = false
        //         }
        //         if(oilAnnualConsmption && oilUnitPrice) {
        //             this.form = Object.assign(val, {
        //                 oil_annual_budget: oilAnnualConsmption * oilUnitPrice,
        //                 gaz_annual_consumption: (oilAnnualConsmption * OIL_EQUIVALENCE) * GAZ_ECONOMY_RATIO,
        //                 gaz_annual_consumption_budget: val.gaz_annual_consumption * val.gaz_price,
        //                 gaz_annual_subscription: val.gaz_subscription * 12,
        //                 gaz_annual_budget: val.gaz_annual_consumption_budget + val.gaz_annual_subscription,
        //                 saving_nosub: val.oil_annual_budget - val.gaz_annual_consumption_budget,
        //                 saving_sub: val.oil_annual_budget - val.gaz_annual_budget
        //             })
        //         }
        //     },
        //     showResults(e) {
        //         this.$validator.validateAll().then(result => {
        //             this.displayResults = result
        //         });
        //     },
        //     togglePopin(state) {
        //         this.displayPopin = state
        //     },
        //     formatNumber(number, options = {}) {
        //         return new Intl.NumberFormat('fr-FR', options).format(number)
        //     },
        //     formatDecimal(number) {
        //         return this.formatNumber(number, {minimumSignificantDigits: 3})
        //     },
        //     formatPrice(price) {
        //         return this.formatNumber(price, {style: 'currency', currency: 'EUR'}).replace('€', '')
        //     },
        //     submit() {
        //         this.$validator.validateAll().then((result) => {
        //             if (result) {
        //                 // Fill out Drupal form inputs
        //                 const getMappedInputId = key => {
        //                     switch (key) {
        //                         case 'oil_annual_consumption': return 'oil_consumption';
        //                         case 'oil_unit_price': return 'oil_price';
        //                         case 'oil_annual_budget': return 'oil_budget';
        //                         case 'gaz_annual_consumption': return 'gaz_consumption';
        //                         case 'gaz_annual_consumption_budget': return 'gaz_consumption_budget';
        //                         case 'gaz_annual_budget': return 'gaz_budget';
        //                         default: return key.toLowerCase();
        //                     }
        //                 };

        //                 for(let [key,value] of Object.entries(this.form)) {
        //                     let inputKey = getMappedInputId(key)
        //                     let input = this.formEl.querySelector(`input[name='calculator_${inputKey}']`)

        //                     if ( input ) {
        //                         input.value = value;
        //                     }
        //                 }
        //                 this.togglePopin(false)
        //                 this.formEl.submit()
        //             }
        //         })
        //     }
        // }
    }
</script>
<script setup>
    import { computed,onUpdated , onMounted,reactive,ref, toRefs,watch,onBeforeUnmount } from 'vue'
    import AnimatedNumber from '../../common/components/AnimatedNumber.vue'
    import Modal from '../../common/components/Modal.vue'
        const props = defineProps({
          dataProps: {type: String,default: ''}
        });
        const OIL_EQUIVALENCE = 10.7
        const GAZ_ECONOMY_RATIO = 0.8
        const displayPopin = ref(false);
        const displayResults = ref(false);
        const displayForm = ref(false);
        const formEl = ref(null);
        const form = ref({
            oil_annual_consumption: null,
            oil_unit_price: null,
            oil_annual_budget: 0,
            gaz_price: 0.00,
            gaz_subscription: 0.00,
            gaz_annual_consumption: 0,
            gaz_annual_consumption_budget: 0,
            gaz_annual_subscription: 0,
            gaz_annual_budget: 0,
            saving_nosub: 0,
            saving_sub: 0,
            email: ''
        });

            function updateFormValues (val) {
                const oilAnnualConsmption = parseInt(val.oil_annual_consumption)
                const oilUnitPrice = parseFloat(val.oil_unit_price)

                if(oilAnnualConsmption || oilUnitPrice) {
                    displayForm = false
                }
                if(oilAnnualConsmption && oilUnitPrice) {
                    form = Object.assign(val, {
                        oil_annual_budget: oilAnnualConsmption * oilUnitPrice,
                        gaz_annual_consumption: (oilAnnualConsmption * OIL_EQUIVALENCE) * GAZ_ECONOMY_RATIO,
                        gaz_annual_consumption_budget: val.gaz_annual_consumption * val.gaz_price,
                        gaz_annual_subscription: val.gaz_subscription * 12,
                        gaz_annual_budget: val.gaz_annual_consumption_budget + val.gaz_annual_subscription,
                        saving_nosub: val.oil_annual_budget - val.gaz_annual_consumption_budget,
                        saving_sub: val.oil_annual_budget - val.gaz_annual_budget
                    })
                }
            };
            function showResults(e) {
                this.$validator.validateAll().then(result => {
                    displayResults = result
                });
            };
            function togglePopin(state) {
               displayPopin = state
            };
            function formatNumber(number, options = {}) {
                return new Intl.NumberFormat('fr-FR', options).format(number)
            };
            function formatDecimal(number) {
                return formatNumber(number, {minimumSignificantDigits: 3})
            };
            function formatPrice(price) {
                return formatNumber(price, {style: 'currency', currency: 'EUR'}).replace('€', '')
            };
            function submit() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        // Fill out Drupal form inputs
                        const getMappedInputId = key => {
                            switch (key) {
                                case 'oil_annual_consumption': return 'oil_consumption';
                                case 'oil_unit_price': return 'oil_price';
                                case 'oil_annual_budget': return 'oil_budget';
                                case 'gaz_annual_consumption': return 'gaz_consumption';
                                case 'gaz_annual_consumption_budget': return 'gaz_consumption_budget';
                                case 'gaz_annual_budget': return 'gaz_budget';
                                default: return key.toLowerCase();
                            }
                        };

                        for(let [key,value] of Object.entries(this.form)) {
                            let inputKey = getMappedInputId(key)
                            let input = formEl.value.querySelector(`input[name='calculator_${inputKey}']`)

                            if ( input ) {
                                input.value = value;
                            }
                        }
                        togglePopin(false)
                        formEl.value.submit()
                    }
                })
            };
            // a  verfier  le nv syntax le watcher
            // watch: {
            //     form: {
            //         handler: 'updateFormValues',
            //         deep: true
            //     }
            // },
            watch(form, () => {
               updateFormValues()
            },{deep: true});

            this.$validator.localize('fr', {
                    attributes: {
                        oil_annual_consumption: 'La consommation de fioul',
                        oil_unit_price: 'La prix unitaire'
                    }
                })
            onMounted(() => {
              let dataProps = dataProps ? JSON.parse(props.dataProps) : {}
                form = {...form, ...props.dataProps}

                formEl.value = this.$el.querySelector("form")
                displayForm.value = formEl.value.querySelector(".webform-confirmation") !== null
            })
</script>
